export default function VisionPolicyIntersection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#FFF5F3] via-white to-[#FFF5F3] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-[#FF6B6B]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-[#FF8E53]/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl mb-6 shadow-lg">
            <i className="ri-flag-line text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            التقاطع مع رؤية المملكة والسياسات العامة
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            كيف يرتبط المشروع بمستهدفات رؤية المملكة 2030 والسياسات العامة للتنمية الشبابية.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          {/* Vision 2030 */}
          <div className="group bg-gradient-to-br from-white to-[#FFF5F3] rounded-3xl border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 p-8">
            <div className="flex items-center justify-center mb-8">
              <img
                src="/2030.png"
                alt="رؤية المملكة 2030"
                className="max-h-32 w-auto object-contain transition-transform duration-300 group-hover:scale-110"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
            </div>
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-6 text-right">
              التقاطع مع رؤية المملكة 2030
            </h3>
            
            <div className="space-y-4 text-right">
              <p className="text-gray-700 leading-relaxed">
                يتقاطع مشروع مساحة العمل المشتركة المتكاملة مع رؤية المملكة 2030 بشكل مباشر، حيث يدعم:
              </p>
              
              <div className="grid gap-3">
                <div className="flex items-start gap-3 bg-white/80 p-4 rounded-xl border border-[#FF6B6B]/10">
                  <div className="w-8 h-8 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">محاور <span className="font-bold">المجتمع الحيوي والاقتصاد المزدهر والوطن الطموح</span></span>
                </div>
                
                <div className="flex items-start gap-3 bg-white/80 p-4 rounded-xl border border-[#FF6B6B]/10">
                  <div className="w-8 h-8 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">تمكين الشباب وتسريع ريادة الأعمال وتعزيز الاقتصاد المعرفي</span>
                </div>
                
                <div className="flex items-start gap-3 bg-white/80 p-4 rounded-xl border border-[#FF6B6B]/10">
                  <div className="w-8 h-8 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">برامج تنمية القدرات البشرية والتحول الوطني وجودة الحياة</span>
                </div>
              </div>
              
              <p className="text-gray-700 leading-relaxed bg-gradient-to-r from-[#FF6B6B]/5 to-[#FF8E53]/5 p-4 rounded-xl border border-[#FF6B6B]/20 mt-4">
                مما يجعله <span className="font-bold text-[#FF6B6B]">منصة عملية لتحقيق مستهدفات الرؤية</span> عبر شراكة فاعلة بين القطاع الخاص والمجتمع.
              </p>
            </div>
          </div>

          {/* Youth Policy */}
          <div className="group bg-gradient-to-br from-white to-[#FFF5F3] rounded-3xl border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 p-8">
            <div className="flex items-center justify-center mb-8">
              <img
                src="/maward.png"
                alt="السياسات العامة للتنمية الشبابية"
                className="max-h-24 w-auto object-contain transition-transform duration-300 group-hover:scale-110"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
            </div>
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-6 text-right">
              التقاطع مع السياسات العامة للتنمية الشبابية
            </h3>
            
            <div className="space-y-4 text-right">
              <div className="bg-gradient-to-r from-[#FF6B6B]/10 to-[#FF8E53]/10 p-5 rounded-xl border border-[#FF6B6B]/20">
                <p className="text-gray-700 leading-relaxed">
                  في عام <span className="font-bold">2024</span> تم تأسيس الإدارة العامة للتنمية الشبابية في وزارة الموارد البشرية والتنمية الاجتماعية، وأطلقت <span className="font-bold text-[#FF6B6B]">السياسات العامة للتنمية الشبابية</span> هذا العام <span className="font-bold">2026</span>.
                </p>
              </div>
              
              <p className="text-gray-800 font-semibold text-lg">
                ويتقاطع مشروعنا مع المجالات والسياسات التالية:
              </p>
              
              <div className="bg-gradient-to-br from-[#FF6B6B]/10 to-[#FF8E53]/10 border-2 border-[#FF6B6B]/30 rounded-2xl p-6 shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center">
                    <i className="ri-community-line text-white text-xl"></i>
                  </div>
                  <div className="text-right flex-1">
                    <p className="font-bold text-gray-900 text-lg">مجال: المشاركة المجتمعية</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#FF8E53] to-[#FFA07A] rounded-xl flex items-center justify-center">
                    <i className="ri-building-line text-white text-xl"></i>
                  </div>
                  <div className="text-right flex-1">
                    <p className="font-bold text-gray-900 text-lg">سياسة: بيئات ومساحات شبابية</p>
                  </div>
                </div>
                
                <div className="bg-white/80 p-4 rounded-xl border border-[#FF6B6B]/20">
                  <p className="text-gray-700 leading-relaxed">
                    توفير بيئات ومساحات مخصصة للشباب لتعزيز <span className="font-semibold">الترابط الاجتماعي والتعبير الإبداعي</span>، مما يساهم في تحسين رفاههم وزيادة مشاركتهم المجتمعية.
                  </p>
                </div>
              </div>
              
              <div className="bg-white/80 p-5 rounded-xl border border-gray-200">
                <p className="text-gray-800 font-semibold mb-3 text-lg">ويمكن تحقيق ذلك من خلال:</p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-shield-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700">وضع معايير لإنشاء <span className="font-semibold">بيئات آمنة وداعمة</span>، وإبرام شراكات لتمويلها واستدامتها.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-megaphone-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700">رفع مستوى الوعي حول <span className="font-semibold">المساحات المتوافرة والخدمات المقدمة</span>.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
